import {
  RequestAccountDeletionMutation,
  RequestAccountDeletionMutationVariables,
} from "@/Apollo/schema";
import { MutationHookOptions, useMutation } from "@apollo/client";
import mutationGQL from "@/Apollo/mutation/requestAccountDeletion.graphql";

export const useRequestAccountDeletion = (
  options?: MutationHookOptions<
    RequestAccountDeletionMutation,
    RequestAccountDeletionMutationVariables
  >
) => {
  return useMutation(mutationGQL, options);
};
